// A contextual session result may open chat only while its original workspace, page, filters and component instance remain current.
export interface AssistantRequestOrigin {
  workspaceId: string | undefined;
  pathname: string;
  search: string;
  scopeKey: string;
  revision: number;
}

export function canOpenAssistantResult(request: AssistantRequestOrigin, current: AssistantRequestOrigin, live: {
  mounted: boolean;
  workspaceId: string | undefined;
  pathname: string;
  search: string;
}): boolean {
  return live.mounted && !!request.workspaceId
    && request.workspaceId === live.workspaceId && request.workspaceId === current.workspaceId
    && request.pathname === live.pathname && request.pathname === current.pathname
    && request.search === live.search && request.search === current.search
    && request.scopeKey === current.scopeKey && request.revision === current.revision;
}
